module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-05.67ef79ff.png";